export default __webpack_public_path__ + "static/media/my-collection-button.364b32d7.svg";